var $ = require("jquery");

/* 
Helper pour formulaires AJAX 

L'�l�ment avec ce contr�lleur doit contenir une balise FORM, et un �l�ment avec l'attribut data-ajaxform-target.

Lorsque le formulaire est soumis, le contenu de l'�l�ment cible sera remplac� par le r�sultat d'une requ�te � la 
page actuelle, avec le formulaire s�rialis� en query string.

Si un �l�ment avec l'attribut data-ajaxform-loader existe, celui-ci sera affich� pendant le chargement.

Si le formulaire a l'attribut data-ajaxform-auto, celui-ci sera soumis automatiquement lorsqu'un de ses champs est modifi�.

Si le navigateur supporte history.replaceState, l'URL sera mise � jour une fois le chargement termin�.

Si l'�l�ment cible contient des �l�ments avec l'attribut data-ajaxform-page, au clic sur ceux-ci le formulaire sera soumis � nouveau, 
avec le param�tre suppl�mentaire p=[VALEUR DE L'ATTRIBUT], et la page scrollera au haut de l'�l�ment avec le contr�lleur.
*/

module.exports = function (element) {
    var $element = $(element);
    var $form = $element.find("form");
    var $target = $element.find("[data-ajaxform-target]");
    var $loader = $element.find("[data-ajaxform-loader]").hide();

    $form.on("submit", function (ev) {
        ev.preventDefault();

        var hasPagination = $form.find("input[name=p]").length > 0;
        var filters = $form.serialize();

        if ($loader.length > 0) {
            $loader.show();
            $target.hide();
        }

        $target.load("?" + filters, function () {
            if ($loader.length > 0) {
                $loader.hide();
                $target.show();
            }

            if (history.replaceState) {
                history.replaceState(null, null, "?" + filters);
            }

            if (hasPagination) {
                $(window).scrollTop($element.offset().top);
            }
        });
    });

    $element.on("click", "[data-ajaxform-reset]", function(ev) {
        ev.preventDefault();

        $form.find("input, select").each(function (i, el) {
            var $el = $(el);
            if ($el.attr("type") == "checkbox") {
                $el.prop("checked", false);
            } else if ($el.attr("type") == "radio" && $el.attr("id") == "all") {
                $el.prop("checked", true);
            } else {
                $el.val("");
            }
        });
        $form.submit();
    });

    $target.on("click", "[data-ajaxform-page]", function(ev) {
        ev.preventDefault();

        var p = $(this).data("ajaxform-page");

        var pField = $('<input type="hidden" name="p" />')
            .val(p)
            .appendTo($form);

        $form.submit();

        pField.remove();
    });

    if ($form.attr("data-ajaxform-auto") != undefined) {
        $form.on("change", "select,input", function () {
            $form.submit();
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/controllers/ajax-form.js
// module id = 243
// module chunks = 0